import { idbHelper } from "./idbHelper";
import { idbItems } from "./indexedDB";
import { brazeAttributeApi } from "../api/brazeBridge";
import { sendEvent } from "../api/nativeBridge";
import { decrypt } from "../api/authFunctions";

export const idbUtil = {
    setVipkok: async (value: any) => {
        if (value === undefined) { return; }
        const prev = await idbHelper.getVipkok();
        await idbHelper.setVipkok(value)
        await idbHelper.setUseVipkokYn(value?.isUsed === 'Y' ? 'Y' : 'N');

        if (prev?.ptnId !== value?.ptnId || prev?.isUsed !== value?.isUsed || prev?.ptnName !== value?.ptnName) {
            brazeAttributeApi.trackingVipkok();
        }
    },
    setCardInfo: async (value: any) => {
        if (!value) { return; }
        const prevCardLevel = await idbHelper.getCardLevel();
        const prevLongTermName = await idbHelper.getLongTermName();
        const prevYouthYn = await idbHelper.getYouthYn();

        await idbHelper.setCardLevel(value.cardLevel);
        await idbHelper.setToken(value.token);
        await idbHelper.setEncKey(value.encKey);
        await idbHelper.setYouthYn(value.youthYn);
        await idbHelper.setLongTermName(value.longTermName);
        await idbHelper.setLongTermCode(value.longTermCode);
        await idbHelper.setIsVIP(value.isVIP);
        await idbHelper.setTotalDiscount(value.totalDiscount);
        await idbUtil.setBarcode(value.barcode);

        if (prevCardLevel !== value.cardLevel) {
            brazeAttributeApi.trackingMemberType();
        }
        if (prevLongTermName !== value.longTermName) {
            brazeAttributeApi.trackingMemberLoyalty();
        }
        if (prevYouthYn !== value.youthYn) {
            brazeAttributeApi.trackingMemberUth();
        }
    },
    setAdAgreeYn: async (value: string) => {
        if (value === undefined) { return; }
        const prev = await idbHelper.getAdAgreeYn();
        await idbHelper.setAdAgreeYn(value);
        await sendEvent('SET_AD_AGREE', { agree: value === 'Y' });
        if (prev !== value) {
            brazeAttributeApi.trackingAdAgreementApp();
        }
    },
    setMarketingAgreeYn: async (value: string) => {
        if (value === undefined) { return; }
        const prev = await idbHelper.getMarketingAgreeYn();
        await idbHelper.setMarketingAgreeYn(value);
        if (prev !== value) {
            brazeAttributeApi.trackingMarketingAgreementStatus();
        }
    },
    setBarcode: async (value: string) => {
        if (value === undefined) { return; }
        await idbHelper.setBarcode(value);
        await sendEvent("SET_UPM_BARCODE", { barcode: value });
    },
    resetUserInfo: async () => {
        // backup data
        const first_loading = await idbItems.get('first_loading');
        
        // await idbItems.del('memberId');
        // await idbItems.del('memberStatus');
        // await idbItems.del('customerName');
        // await idbItems.del('isVIP');
        // await idbItems.del('userStatus');

        await idbItems.clear();

        // restore data
        await idbItems.set('first_loading', first_loading);

    },
    resetUserInfoMin: async () => {
        // backup data
        const deviceSystemInfo = await idbUtil.getDeviceSystemInfo();
        const sessionInfo = await idbUtil.getSessionInfo();

        await idbItems.clear();

        // restore data
        await idbUtil.setObjectEntries(deviceSystemInfo);
        await idbUtil.setObjectEntries(sessionInfo);
        
    },
    setSessionInfo: async (value: any, mcpTrKey: string) => {
        if (!value) { return;}

        if (value.subNo !== undefined) {
            await idbItems.set('subNo', value.subNo ?? '');
        }
        if (value.subCustNo !== undefined) {
            await idbItems.set('subCustNo', value.subCustNo ?? '');
        }
        if (value.serviceYackReqStatus !== undefined) {
            await idbItems.set('serviceYackReqStatus', value.serviceYackReqStatus);
        }
        if (value.serviceNotiYn !== undefined) {
            await idbItems.set('serviceNotiYn', value.serviceNotiYn);
        }
        if (value.maketingInfoYn !== undefined) {
            await idbItems.set('maketingInfoYn', value.maketingInfoYn);
        }
        if (value.payExistYn !== undefined) {
            await idbItems.set('payExistYn', value.payExistYn ?? '');
        }
        if (value.lossPhone !== undefined) {
            await idbItems.set('lossPhone', value.lossPhone);
        }
        if (value.emulUse !== undefined) {
            await idbItems.set('emulUse', value.emulUse);
        }
        if (value.moneyMeUse !== undefined) {
            await idbItems.set('moneyMeUse', value.moneyMeUse);
        }
        if (value.ci !== undefined) {
            if (mcpTrKey) {
                const ci = value.ci ? await decrypt(mcpTrKey, value.ci) : '';
                await idbItems.set('ci', ci);
            } else {
                await idbItems.set('ci', value.ci ?? '');
            }
        }
        if (value.dataDogSessionSampleRate !== undefined) {
            await idbItems.set('dataDogSessionSampleRate', value.dataDogSessionSampleRate);
        }
        if (value.updateStatus !== undefined) {
            await idbItems.set('updateStatus', value.updateStatus);
        }
        if (value.sessionKey !== undefined) {
            await idbItems.set('sessionKey', value.sessionKey ?? '');
            await sendEvent('SET_AUTHORIZATION', {authorization: value.sessionKey ?? ''});
        }
        if (value.memberId !== undefined) {
            await idbItems.set('memberId', value.memberId ?? '');
            await sendEvent('SET_MEMBER_ID', {memberId: value.memberId ?? ''});
        }
        if (value.birthday !== undefined) {
            await idbItems.set('birthday', value.birthday ?? '');
            await sendEvent('SET_USER_BIRTH', {userBirth: value.birthday ?? ''});
        }        
        if (value.customerName !== undefined) {
            await idbItems.set('customerName', value.customerName ?? '');
            await sendEvent('SET_USER_NAME', {userName: value.customerName ?? ''});
        }
        if (value.encMemberId !== undefined) {
            await idbItems.set('encMemberId', value.encMemberId ?? '');
            await sendEvent("SET_ENC_MEMBER_ID", {encMemberId: value.encMemberId ?? ''});
        }
        if (value.gender !== undefined) {   
            await idbItems.set('gender', value.gender ?? '');
            await sendEvent('SET_USER_GENDER', {gender: value.gender ?? ''});
        }

        await idbUtil.setMemberStatus(value.memberStatus);
        await idbUtil.setMarketingAgreeYn(value.marketingAgreeYn);
        if (await idbHelper.getPlatform() === 'AOS') {
            if (value.telcoCode !== null && value.telcoCode !== undefined) {
                await idbUtil.setTelcoCode(value.telcoCode);
            }
        } else {
            await idbUtil.setTelcoCode(value.telcoCode ?? '');
        }

    },
    getSessionInfo: async () => {
        return {
            userStatus: await idbItems.get('userStatus'), // idb 'userStatus'에 저장된 값은 session의 memberStatus
            memberId: await idbItems.get('memberId'),
            subNo: await idbItems.get('subNo'),
            subCustNo: await idbItems.get('subCustNo'),
            customerName: await idbItems.get('customerName'),
            birthday: await idbItems.get('birthday'),
            gender: await idbItems.get('gender'),
            serviceYackReqStatus: await idbItems.get('serviceYackReqStatus'),
            maketingInfoYn: await idbItems.get('maketingInfoYn'),
            sessionKey: await idbItems.get('sessionKey'),
            telcoCode: await idbItems.get('telcoCode'),
            payExistYn: await idbItems.get('payExistYn'),
            updateStatus: await idbItems.get('updateStatus'),
            lossPhone: await idbItems.get('lossPhone'),
            emulUse: await idbItems.get('emulUse'),
            moneyMeUse: await idbItems.get('moneyMeUse'),
            dataDogSessionSampleRate: await idbItems.get('dataDogSessionSampleRate'),
            ci: await idbItems.get('ci'),
            encMemberId: await idbItems.get('encMemberId'),
            marketingAgreeYn: await idbItems.get('marketingAgreeYn'),
            serviceNotiYn: await idbItems.get('serviceNotiYn'),
        }
    },
    getDeviceSystemInfo: async () => {
        return {
            ctn: await idbItems.get('ctn'),
            first_loading: await idbItems.get('first_loading'),
            platform: await idbItems.get('platform'),
            telcoCode: await idbItems.get('telcoCode'),
            osVersion: await idbItems.get('osVersion'),
            appVersion: await idbItems.get('appVersion'),
            model: await idbItems.get('model'),
            adid: await idbItems.get('adid'),
        }
    },
    setObjectEntries: async (data: any) => {
        for (const [key, value] of Object.entries(data)) {
            if (value !== undefined) {
                await idbItems.set(key, value);
            }
        }
    },
    setMemberStatus: async (value: string) => {
        if (value === undefined) { return; }
        // 'memberStatus' -> 'userStatus' : 세션의 memberStatus를 'userStatus'로 저장하고 있음
        await idbItems.set('userStatus', value);
        await sendEvent("SET_MEMBERSTATUS", {memberStatus: value});
    },
    getMemberStatus: async () => {
        // 'memberStatus' -> 'userStatus' : 세션의 memberStatus를 'userStatus'로 저장하고 있음
        /*
            빈값 : 미가입자
            41 : 자사, 19세 이상, 소액 VIP
            42 : 자사, 19세 이상, 소액일반
            43 : 자사, 소액 VIP (오프라인 결제 부가서비스 미가입자) 
            44 : 자사, 19세 미만, 소액 불가
            45 : 자사, 법인, U+멤버십 불가, 소액불가
            46 : 타사
            47 : 자사, 선불폰, 소액불가, U+멤버십 사용불가
            48 : 자사, 14세 미만
            49 : 자사, 법인, U+맴버십 가능,소액불가
        */
        return await idbItems.get('userStatus');
    },
    setMemberStatusGroup: async (value: string) => {
        if (value === undefined) { return; }
        await idbItems.set('memberStatus', value);
    },
    getMemberStatusGroup: async () => {
        /*
            0 : 미가입자
            1 : ['41', '42', '43', '44', '49'].includes(memberStatus) && ['6', '8'].includes(cardLevel) 
            2 : ['41', '42', '43', '44', '49'].includes(memberStatus) && cardLevel === '7'
            3 : memberStatus === '48' && ['6', '8'].includes(cardLevel) 
            4 : memberStatus === '48' && cardLevel === '7'
            5 : U+멤버십/소액결제 불가 ['45', '46', '47'].includes(memberStatus)

            *등급 코드(cardLevel)
            6 : VVIP
            7 : 우수
            8 : VIP
        */
        return await idbItems.get('memberStatus');
    },
    setTelcoCode: async (value: string) => {
        if (value === undefined) { return; }
        await idbHelper.setTelcoCode(value);
        await sendEvent('SET_CARRIER', {carrier: value});
    },
    setLatestAppStartTime: async (value: Date = new Date()) => {
        if (value === undefined) { return; }
        const formattedTime = formatDateTime(value);
        await idbItems.set('latestAppStartTime', formattedTime);
    },
    getLatestAppStartTime: async () => {
        const latestAppStartTime = await idbItems.get('latestAppStartTime');
        if (latestAppStartTime) {
            return new Date(latestAppStartTime.replace(' ', 'T'));
        }
        return null;
    },
    delLatestNavigateTabTime: async () => {
        await idbItems.del('latestNavigateTabTime');
    },
    setLatestNavigateTabTime: async (value: Date = new Date()) => {
        if (value === undefined) { return; }
        const formattedTime = formatDateTime(value);
        await idbItems.set('latestNavigateTabTime', formattedTime);
    },
    getLatestNavigateTabTime: async () => {
        const latestNavigateTabTime = await idbItems.get('latestNavigateTabTime');
        if (latestNavigateTabTime) {
            return new Date(latestNavigateTabTime.replace(' ', 'T'));
        }
        return null;
    },
    setTimeStamp: async (value: String) => {
        if (value === undefined) { return; }
        await idbItems.set('timeStamp', value);
    },
    getTimeStamp: async () => {
        return await idbItems.get('timeStamp');
    },

}

/*
    * Date 객체를 yyyy-MM-dd HH:mm:ss 형식의 문자열로 변환
    * @param date - Date 객체
    * @returns yyyy-MM-dd HH:mm:ss 형식의 문자열
    */
function formatDateTime(date: Date) {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
